import { render, staticRenderFns } from "./Specialties.vue?vue&type=template&id=052e9578&scoped=true&"
import script from "./Specialties.vue?vue&type=script&lang=js&"
export * from "./Specialties.vue?vue&type=script&lang=js&"
import style0 from "./Specialties.vue?vue&type=style&index=0&id=052e9578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052e9578",
  null
  
)

export default component.exports